import { ListFilterCustomSelect } from "../../components/ListFilterCustomSelect";
import {
  AUTOMATION_CATEGORY_FILTERS,
  NotificationAutomation,
  AutomationCategory,
} from "./notificationsListQuery";
import { notificationChannelBadge } from "./notificationListDisplay";

type Props = {
  automations: NotificationAutomation[];
  categoryFilter: AutomationCategory;
  loading: boolean;
  onCategoryChange: (value: AutomationCategory) => void;
};

export function NotificationsAutomationsSection({
  automations,
  categoryFilter,
  loading,
  onCategoryChange,
}: Props) {
  return (
    <section>
      <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4">
        <p className="min-w-0 flex-1 text-sm leading-snug text-slate-500">
          Catálogo estático das automações de notificação do sistema (sem toggle on/off nesta fase).
        </p>

        <ListFilterCustomSelect
          label="Escopo"
          value={categoryFilter}
          options={AUTOMATION_CATEGORY_FILTERS}
          onChange={(value) => onCategoryChange(value as AutomationCategory)}
          className="w-full shrink-0 sm:w-auto sm:min-w-[220px]"
        />
      </div>

      {loading ? (
        <div className="px-1 py-8 text-center text-sm text-slate-500">
          Carregando automações...
        </div>
      ) : automations.length === 0 ? (
        <div className="px-1 py-8 text-center text-sm text-slate-500">
          Nenhuma automação encontrada para este filtro.
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200">
          <table className="min-w-[720px] w-full border-separate border-spacing-0 text-[13px] font-[inherit]">
            <thead className="bg-slate-50">
              <tr>
                <th className="rounded-tl-xl px-3 py-2 text-left text-xs font-semibold text-slate-700">
                  Nome
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-700">
                  Canal
                </th>
                <th className="rounded-tr-xl px-3 py-2 text-left text-xs font-semibold text-slate-700">
                  Gatilho
                </th>
              </tr>
            </thead>
            <tbody>
              {automations.map((automation, index) => {
                const channelBadge = notificationChannelBadge(automation.channel);
                return (
                  <tr
                    key={automation.key}
                    className={index % 2 === 0 ? "bg-white" : "bg-slate-50/90"}
                  >
                    <td className="px-3 py-2.5 font-medium text-slate-800">{automation.name}</td>
                    <td className="px-3 py-2.5">
                      <span
                        className={`inline-flex w-fit items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-tight ${channelBadge.className}`}
                      >
                        {channelBadge.label}
                      </span>
                    </td>
                    <td className="px-3 py-2.5 text-slate-600">{automation.trigger}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
